import { render, staticRenderFns } from "./MarkdownFieldSettingsFields.vue?vue&type=template&id=b73cf34c&scoped=true&"
import script from "./MarkdownFieldSettingsFields.vue?vue&type=script&lang=ts&"
export * from "./MarkdownFieldSettingsFields.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownFieldSettingsFields.vue?vue&type=style&index=0&id=b73cf34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73cf34c",
  null
  
)

export default component.exports